module.exports = __webpack_public_path__ + "static/media/logo-aht-black.5a743f36.png";